import "styles/css/YouTube.scss";

import $ from "jquery";

export default function youtube(embedId:string) {
	setTimeout(() => _events.invoke("resize-video-wrappers"), 100);
	return (
		<div className="video-wrapper">
			<iframe
			  width="100%"
			  height="100%"
			  src={`https://www.youtube.com/embed/${embedId}?rel=0`}
			  frameBorder="0"
			  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			  allowFullScreen
			  title="Embedded youtube"
			/>
		</div>
	)
}